import URL from '../url'
import Request from '../request'

/**
 *
 */
export const videoDirectoryGetRootService = (page, filterText) =>
  new Request(URL.API, URL.VIDEO_DIRECTORY_GET_ROOT).post({
    currentPage: page - 1,
    pageSize: 20,
    filterText: filterText || '',
  })

/**
 *
 */
export const mediaDirectoryGetRootService = (page, filterText) =>
  new Request(URL.API, URL.MEDIA_DIRECTORY_GET_ROOT).post({
    currentPage: page - 1,
    pageSize: 20,
    filterText,
  })

/**
 *
 * @param {*} id
 */
export const mediaDirectoryGetService = request =>
  new Request(URL.API, URL.MEDIA_DIRECTORY_GET).post(request)
